import React from "react";
import { FaInfoCircle, FaLink } from "react-icons/fa";

const bannerStyle = {
  backgroundColor: "#EAF3FF",
  border: "1px solid #B9D4FB",
  borderRadius: "10px",
  padding: "14px 18px",
  display: "flex",
  alignItems: "center",
  gap: "24px",
};

const titleStyle = {
  fontFamily: "Poppins, sans-serif",
  fontSize: "13px",
  fontWeight: 700,
  color: "#0A3652",
  lineHeight: 1.4,
};

const bodyStyle = {
  fontFamily: "Poppins, sans-serif",
  fontSize: "13px",
  fontWeight: 400,
  color: "#0A3652",
  lineHeight: 1.5,
};

const ctaStyle = {
  backgroundColor: "#2C64EF",
  border: "none",
  borderRadius: "8px",
  color: "#FFFFFF",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 600,
  fontSize: "12px",
  padding: "8px 14px",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const displayName = (match) =>
  match?.guardianName ||
  `${match?.firstName || ""} ${match?.lastName || ""}`.trim() ||
  match?.appUser?.email ||
  "this parent/guardian";

const displayId = (match) =>
  match?.appUser?.userDisplayId ||
  (match?.appUser?.userAutoGenId != null
    ? `USR-${String(match.appUser.userAutoGenId).padStart(4, "0")}`
    : "");

const GuardianMatchBanner = ({ match, accepted, onUse }) => {
  if (!match || !match.email) return null;

  const state = Number(match.state) || 1;
  let title = "New Parent/Guardian";
  let body = "No existing parent/guardian or Numente account was found for this email.";
  let cta = null;
  // States 3/4: three even columns — [icon+title] | [details] | [CTA]
  let threeColumn = false;

  if (state === 2) {
    title = "Existing Numente App Account Found";
    body = `${displayName(match)}${displayId(match) ? ` (${displayId(match)})` : ""} matches this email.`;
    cta = "Use This Parent / Guardian";
  } else if (state === 3) {
    title = "Existing Parent/Guardian Found";
    body = (
      <>
        <div>
          <strong>Parent/Guardian Match:</strong> {displayName(match)}
        </div>
        <div>
          <strong>Numente App:</strong> Not Connected
        </div>
      </>
    );
    cta = "Use This Parent / Guardian";
    threeColumn = true;
  } else if (state === 4) {
    title = "Existing Parent/Guardian Found";
    body = (
      <>
        <div>
          <strong>Parent/Guardian Match:</strong> {displayName(match)}
        </div>
        <div>
          <strong>Numente App:</strong> Connected
        </div>
      </>
    );
    cta = "Use this Parent / Guardian & Link App";
    threeColumn = true;
  }

  const ctaButton = cta ? (
    <button
      type="button"
      onClick={onUse}
      disabled={accepted}
      style={{
        ...ctaStyle,
        marginLeft: threeColumn ? 0 : "auto",
        opacity: accepted ? 0.7 : 1,
        cursor: accepted ? "default" : "pointer",
      }}
    >
      <FaLink size={12} />
      {accepted ? "Selected" : cta}
    </button>
  ) : null;

  if (threeColumn) {
    return (
      <div style={bannerStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flex: "1 1 0",
            minWidth: 0,
          }}
        >
          <FaInfoCircle size={15} color="#2C64EF" style={{ flexShrink: 0 }} />
          <span style={titleStyle}>{title}</span>
        </div>
        <div
          style={{
            ...bodyStyle,
            flex: "1 1 0",
            minWidth: 0,
          }}
        >
          {body}
        </div>
        {ctaButton}
      </div>
    );
  }

  // New / existing app account: icon + bold title + body inline, CTA on right
  return (
    <div style={bannerStyle}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "8px 12px",
          flex: "1 1 auto",
          minWidth: 0,
        }}
      >
        <FaInfoCircle size={15} color="#2C64EF" style={{ flexShrink: 0 }} />
        <span style={titleStyle}>{title}</span>
        <div style={bodyStyle}>{body}</div>
      </div>
      {ctaButton}
    </div>
  );
};

export default GuardianMatchBanner;
